import { useEffect, useState } from "react";
import { adminListJobs, adminRefundJob } from "../../api";
import { useSession } from "../../state";

type AdminJob = {
  id: string;
  user_email: string | null;
  user_id: string;
  status: string;
  quality: string;
  charged: boolean;
  prompt: string;
  moderation_reason: string | null;
  error: string | null;
  created_ip: string | null;
  image_url: string | null;
  created_at: string;
};

const STATUSES = ["", "pending", "moderating", "submitted", "running", "completed", "failed", "moderation_rejected"];

export function AdminJobs() {
  const { token } = useSession();
  const [rows, setRows] = useState<AdminJob[]>([]);
  const [statusFilter, setStatusFilter] = useState("");
  const [userFilter, setUserFilter] = useState("");
  const [busy, setBusy] = useState<string | null>(null);

  const load = async () => {
    const t = (await token())!;
    setRows(await adminListJobs(t, { status: statusFilter || undefined, user: userFilter || undefined }));
  };
  useEffect(() => { load(); }, [statusFilter]);

  const refund = async (id: string) => {
    if (!confirm("refund 1 credit/token to the user for this job?")) return;
    setBusy(id);
    try {
      const t = (await token())!;
      const r = await adminRefundJob(t, id);
      alert(JSON.stringify(r));
      await load();
    } catch (e: any) { alert(e.message); }
    finally { setBusy(null); }
  };

  return (
    <div>
      <div className="flex gap-2 mb-4 items-stretch">
        <select
          className="input w-40 shrink-0 text-xs py-2 px-3"
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
        >
          {STATUSES.map((s) => <option key={s} value={s}>{s || "all statuses"}</option>)}
        </select>
        <input
          className="input flex-1 text-base"
          placeholder="user (sub or email)"
          value={userFilter}
          onChange={(e) => setUserFilter(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && load()}
        />
        <button onClick={load} className="btn-ghost text-sm bg-cream-dark px-4">filter</button>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-left text-ink-mute text-xs uppercase tracking-wider">
            <tr>
              <th>when</th><th>user</th><th>ip</th><th>image</th>
              <th>status</th><th>quality</th><th>charged</th><th>prompt</th><th>actions</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((j) => (
              <tr key={j.id} className="border-t border-ink/10 align-top">
                <td className="py-2 pr-2 text-xs whitespace-nowrap">{new Date(j.created_at).toLocaleString()}</td>
                <td className="pr-2 text-xs">{j.user_email}</td>
                <td className="pr-2 text-xs font-mono">{j.created_ip || "—"}</td>
                <td className="pr-2">
                  {j.image_url ? (
                    <a href={j.image_url} target="_blank" rel="noreferrer" title="open original">
                      <img src={j.image_url} alt="" className="w-12 h-12 object-cover rounded-sm border border-ink/10" />
                    </a>
                  ) : <span className="text-xs text-ink-mute">expired</span>}
                </td>
                <td className="pr-2 text-xs">
                  {j.status}
                  {j.moderation_reason && <div className="text-coral-dark">{j.moderation_reason}</div>}
                  {j.error && <div className="text-coral-dark">{j.error}</div>}
                </td>
                <td className="pr-2 text-xs">{j.quality}</td>
                <td className="pr-2 text-xs">{j.charged ? "✓" : "—"}</td>
                <td className="pr-2 text-xs max-w-md">{j.prompt}</td>
                <td className="py-2">
                  {j.charged && (
                    <button onClick={() => refund(j.id)} disabled={busy===j.id}
                            className="btn-ghost text-xs px-2 py-1 bg-cream-dark">refund</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
